import { render, staticRenderFns } from "./Pregnant.vue?vue&type=template&id=5dd8856c&scoped=true&"
import script from "./Pregnant.vue?vue&type=script&lang=js&"
export * from "./Pregnant.vue?vue&type=script&lang=js&"
import style0 from "./Pregnant.vue?vue&type=style&index=0&id=5dd8856c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8856c",
  null
  
)

export default component.exports